import { useObjects } from '@hooks/useObjects.js';

/**
 * The taxonomy node the details panel shows, resolved from the uuid the tree
 * selected (state lifted into `Objects`) against the node list for the active
 * project type. Shares the tree's cached query, so no extra request.
 *
 * A uuid that is not in the current list — after a project-type or org switch,
 * say — resolves to `null`, and the panel falls back to its empty state.
 *
 * @param {string | null} selectedUuid
 * @param {string} mode - the active `PROJECT_MODE` value
 * @returns {{ selectedObject: object | null, objects: object[], isLoading: boolean }}
 */
export const useSelectedObject = (selectedUuid, mode) => {
	const { nodes, isLoading } = useObjects(mode, { withCounts: true });
	const selectedObject = selectedUuid
		? (nodes.find(node => node.uuid === selectedUuid) ?? null)
		: null;

	return { selectedObject, objects: nodes, isLoading };
};
